<!--  -->
<template>
  <van-popup
    v-model="showBank"
    round
    safe-area-inset-bottom
    position="bottom"
    @close="close"
    :style="{ height: '70%' }"
  >
    <div class="close">
      <span>支持的银行</span>
    </div>
    <ul class="banklistBox">
      <li v-for="item in banklist" class="banklistLi" :key="item.name">
        <img
          style="width: 20px; margin-right: 4px"
          :src="item.bankPicUrl"
          alt=""
        />{{ item.bankName }}
      </li>
      <li class="banklistLi" v-if="banklist.length % 2 === 1"></li>
    </ul>
  </van-popup>
</template>

<script>
import { Toast } from 'vant';

export default {
  name: 'BankSupport',
  data() {
    return {
      showBank: false,
      banklist: [],
    };
  },
  mounted() {
    const {
      getbanklist,
    } = this.$api.CommonForms;
    getbanklist().then((res) => {
      if (res.success) {
        this.banklist = res.data;
      } else {
        Toast(res.returnMessage);
      }
    });
  },
  props: {
    showBankProps: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    showBankProps(newVal) {
      this.showBank = newVal;
    },
  },
  methods: {
    close() {
      this.$emit('setShowBank', false);
    },
  },
};
</script>
<style scoped>
.banklistBox {
  width: 100%;
  display: flex;
  justify-content: left;
  flex-flow: row wrap;
  flex: 1;
  overflow: scroll;
  height: 90%;
}
.banklistLi {
  width: 50%;
  height: 45px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.close {
  width: 100%;
  height: 40px;
  line-height: 40px;
  position: relative;
  border-bottom: 1px solid #e9f0f5;
  font-family: PingFangSC-Regular;
  font-size: 17px;
  color: #000000;
  letter-spacing: 0;
  text-align: center;
}
.support {
  position: absolute;
  top: 11px;
  right: 15px;
  font-size: 14px;
  color: #ff6538;
}
</style>
